import { getMetaValue } from "helpers"
import ky from "ky"

const reloadWhenSignedOut = ({ response }) => {
  if (response.status === 401) {
    window.location.reload()
    // Hold the request open until the reload replaces the page, so callers don't show an error first.
    return new Promise(() => {})
  }
}

export default ky.extend({
  hooks: {
    beforeRequest: [
      ({ request }) => {
        request.headers.set("X-CSRF-Token", getMetaValue("csrf-token"))
      }
    ],
    afterResponse: [reloadWhenSignedOut]
  },
  retry: 0
})
